(() => {
  const target = '/collections/road-framesets';
  const heroImage = 'https://cdn.shopify.com/s/files/1/0742/9174/0762/files/velo-atlas-premium-road-framesets-homepage-hero.png?v=1786252256';
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();

  function sameStorePath(href) {
    try {
      const url = new URL(href || '', window.location.origin);
      return url.origin === window.location.origin ? url.pathname : '';
    } catch (error) {
      return '';
    }
  }

  function fixFramesetLinks() {
    document.querySelectorAll('a[href]').forEach((anchor) => {
      const label = clean(anchor.textContent || anchor.getAttribute('aria-label'));
      const path = sameStorePath(anchor.getAttribute('href'));
      const isFramesetLabel = /^(browse\s+)?framesets?$/i.test(label) || /request a live quote/i.test(label);
      const isWrongFramesetTarget = path === '/collections/all' || path === '/products' || path === '/collections' || path === '/collections/frameset' || path === '/collections/framesets' || path === '/collections/road-frameset';
      if (isFramesetLabel && isWrongFramesetTarget) anchor.setAttribute('href', target);
    });
  }

  function ensureHomepageHero() {
    const main = document.querySelector('#MainContent[data-template^="index"]');
    if (!main) return;
    const hero = main.querySelector('.shopify-section:first-child, [id*="__hero_jVaWmY"]');
    if (!hero) return;
    hero.classList.add('va-home-hero-section', 'va-image-hero');
    hero.style.setProperty('--va-home-hero-image', `url("${heroImage}")`);

    let hotspot = hero.querySelector('.va-image-hero-hotspot');
    if (!hotspot) {
      hotspot = document.createElement('a');
      hotspot.className = 'va-image-hero-hotspot';
      hotspot.textContent = 'Browse Framesets';
      hotspot.setAttribute('aria-label', 'Browse Road Framesets');
      hero.appendChild(hotspot);
    }
    if (hotspot.getAttribute('href') !== target) hotspot.setAttribute('href', target);
  }

  let queued = false;
  function run() {
    queued = false;
    ensureHomepageHero();
    fixFramesetLinks();
  }
  function queueRun() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', run, { once: true });
  [250, 750, 1500, 3000, 6000].forEach((delay) => window.setTimeout(run, delay));
  new MutationObserver(queueRun).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'class'] });
})();
